import React from 'react';
const ListItemContext = /*#__PURE__*/React.createContext(null);
/**
 * @private
 */

export const ListItemProvider = ListItemContext.Provider;
/**
 * @private
 */

export function useListItemContext() {
  return React.useContext(ListItemContext);
}